import { defineComponent as _defineComponent } from 'vue';
import { onMounted, ref } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import CountUpWrapper from 'vue-countup-v3';
export default /*#__PURE__*/ _defineComponent({
    __name: 'count-up',
    props: {
        endVal: { type: Number, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        gsap.registerPlugin(ScrollTrigger);
        const props = __props;
        const counterRef = ref();
        const counter = ref();
        const setCounter = (counterEl) => {
            counter.value = counterEl;
        };
        onMounted(() => {
            if (counterRef.value) {
                ScrollTrigger.create({
                    trigger: counterRef.value,
                    start: 'top bottom',
                    onEnter: () => {
                        counter.value?.reset();
                        counter.value?.start();
                    },
                });
            }
        });
        const __returned__ = { props, counterRef, counter, setCounter, get CountUpWrapper() { return CountUpWrapper; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
